export default [
    {
        id: 1,
        name_ca: 'Desconeguda',
        name_es: 'Desconocida',
        name_en: 'Unknown'
    }, {
        id: 2,
        name_ca: 'Cap',
        name_es: 'Ninguno',
        name_en: 'None'
    }, {
        id: 3,
        name_ca: 'Fusta vernissada',
        name_es: 'Madera barnizada',
        name_en: 'Varnished wood'
    }, {
        id: 4,
        name_ca: 'Fusta pintada',
        name_es: 'Madera pintada',
        name_en: 'Painted wood'
    }, {
        id: 5,
        name_ca: 'Alumini',
        name_es: 'Aluminio',
        name_en: 'Aluminum'
    }, {
        id: 6,
        name_ca: 'Acer',
        name_es: 'Acero',
        name_en: 'Steel'
    }, {
        id: 7,
        name_ca: 'PVC',
        name_es: 'PVC',
        name_en: 'PVC'
    }, {
        id: 8,
        name_ca: 'Vidre',
        name_es: 'Vidrio',
        name_en: 'Glass'
    }
]





// WEBPACK FOOTER //
// ./src/options/interior_carpentry_types.js